import { Select as AntdSelect } from "antd";
import { SelectProps as AntdSelectProps } from "antd/lib/select";
import React from "react";

export type MySelectProps = AntdSelectProps;

export interface SelectStaticMethods {
  Option: typeof AntdSelect.Option;
  OptGroup: typeof AntdSelect.OptGroup;
}

const SelectPolyfill: React.FC<MySelectProps> & SelectStaticMethods = (
  props,
) => {
  return <AntdSelect {...props} />;
};

SelectPolyfill.Option = AntdSelect.Option;
SelectPolyfill.OptGroup = AntdSelect.OptGroup;

export default SelectPolyfill;
